import { Component } from '@angular/core';
import { IBreadcrumbsItem } from '../../module/shared/components/breadcrumbs/breadcrumbs.component';
import { IServicesItem } from '../../module/catalog/components/services-mobile/services-mobile.component';
import { SharedModule } from '../../module/shared/shared.module';
import { PageOffersComponent } from '../shared/page-offers/page-offers.component';
import { KeyValuePipe } from '@angular/common';
import { AppModule } from '../../../app.module';

interface IServiceData {
  title: string;
  items: IServicesItem[];
}

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [SharedModule, PageOffersComponent, KeyValuePipe, AppModule],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
})
export class ServicesComponent {
  breadcrumbs: IBreadcrumbsItem[] = [
    {
      title: 'Главная',
      href: '/',
    },
    {
      title: 'Сервисы',
      href: '',
    },
  ];

  data: Record<string, IServiceData> = {
    mortgage: {
      title: 'Услуги для ипотеки',
      items: [
        { slug: 'https://client.ndv.ru/cabinet/mortgage/', caption: 'Личный кабинет', iconName: 'mortgage_house', title: 'Моя ипотека' },
        { slug: '/ipoteka/', iconName: 'keys', caption: 'Рассчет ипотеки', title: 'Ипотечный калькулятор' },
        // {
        //   slug: '/ipoteka/documents/',
        //   iconName: 'briefcase-and-documents',
        //   caption: 'Документы для ипотеки',
        //   title: 'Документы для одобрения',
        // },
        // {
        //   slug: '/services/mortgage-insurance/',
        //   iconName: 'user-access-control',
        //   caption: 'Документы для страхования',
        //   title: 'Ипотечное страхование',
        // },
        // {
        //   slug: '/ipoteka/consultation/',
        //   iconName: 'fluent-color_notebook-question-mark-24',
        //   caption: 'Помощь по вопросам',
        //   title: 'Консультация',
        // },
        // { slug: '/ipoteka/consultation/', iconName: 'man-paperwork', caption: 'Для ипотеки', title: 'Оценка объекта' },
      ],
    },
    buy: {
      title: 'Покупка и продажа',
      items: [
        { slug: 'https://client.ndv.ru/authentication/start', iconName: 'flat-color-icons_plus', title: 'Разместить объявление' },
        { slug: '/novostrojki/search', iconName: 'i-building3', title: 'Новостройки по цене застройщика' },
        { slug: 'https://client.ndv.ru/cabinet/ads-list/', iconName: 'app', title: 'Мои объявления', caption: 'Ваши объявления' },
        { slug: 'https://client.ndv.ru/cabinet/main/', iconName: 'keys2', title: 'Моя недвижимость' },
        { slug: '/kupit-kvartiru/podbor-agenta/', iconName: 'umbrella2', caption: 'Покупка / продажа', title: 'Подбор риелтора' },
        { slug: '/services/security/', iconName: 'padlock2', title: 'Гарантия безопасности сделки' },
        {
          slug: '/kupit-kvartiru/komfortnaya-sdelka',
          iconName: 'emojione_handshake-light-skin-tone',
          caption: 'Покупка / продажа',
          title: 'Комфортная сделка',
        },
        { slug: '/kupit-kvartiru/ocenka', iconName: 'graph', caption: 'Бесплатно', title: 'Оценка квартиры' },
      ],
    },
    developers: {
      title: 'Застройщикам',
      items: [
        { slug: '/konsalting-i-analitika/', iconName: 'diagram', caption: 'Поддержка', title: 'Аналитика и консалтинг' },
        { slug: '/zastrojshhikam/', iconName: 'i-building2', caption: 'Поддержка', title: 'Застройщикам' },
      ],
    },
  };

  unsorted = () => 0;
}
